<template> 
  <div class="share" v-if="error">
    <div class="dashboard">
    <h2 style="text-transform: uppercase;">{{ $t('records.electronicRegister') }}</h2>

     <div class="card">

      <div class="card-title">
        <h2>{{ $t('records.newRecord') }}</h2>
      </div>

      <div class="card-content">
        <p>{{ $t('records.newRecordNotFound') }}</p>
      </div>
     </div>
    </div>
  </div>
  <div class="share" v-else-if="loaded" id="new-record">
    <div class="contenedor-body">
      <div class="dashboard visible-xs">
        <div class="card">
          <div class="card-title">
            <h2>{{ $t('records.receiver') }}</h2>
          </div>

          <div class="card-content">
            <h4>{{ this.inbox }}</h4>
            <br />
            <p><strong>{{ $t('records.addressee') }}</strong></p>
            <p>{{ this.receiver }}</p>
          </div>
        </div>

        <div class="card">
          <div class="card-title">
            <h2>{{ $t('records.recordInfo') }}</h2>
          </div>

          <div class="card-content">
            <p>{{ $t('records.email') }}</p>
            <input class="input input--block" v-focus type="email" v-model.trim="email" :disabled="isLogged">

            <p>{{ $t('records.subject') }}</p>
            <input class="input input--block" type="text" v-model.trim="subject">

            <p>{{ $t('records.message') }}</p>
            <textarea class="input input--block" type="text" v-model.trim="message" rows="5"></textarea>

            <p>{{ $t('records.files') }}</p>
            <div>
              <listing ref="downloads-list"></listing>
            </div>
            <input style="display:none" type="file" id="upload-file-to-record" @change="uploadInput($event)" multiple>
            <button :aria-label="$t('buttons.addFile')" :title="$t('buttons.addFile')" @click="addFile" id="buttonAddFile" class="button button--flat" type="submit" >
              <span>{{ $t('buttons.addFile') }}</span>
            </button>
            <br>
            <button :aria-label="$t('records.send')" :title="$t('records.send')" @click="submit" id="buttonAddFile" class="button button--flat" type="submit" >
              <span>{{ $t('records.send') }}</span>
            </button>
          </div>
        </div>
      </div>
      <div class="contenedor-publicidad">
        <div class="texto">
          <div>
            <h3>{{ $t('records.getTouch') }}</h3>
            <h2>{{ $t('records.confidentialSecure') }}</h2>
          </div>
          <img src="/img/icons/Login/ibbLogoWhiteV.svg">
        </div>
        <p>{{ $t('login.differentCloud') }}</p>
        <router-link to="/register" :title="$t('login.signup')" :aria-label="$t('login.signup')">
          <span>{{ $t('login.signup') }}</span>
        </router-link>
        <div class="contenedor-imagen">
          <img src="/img/icons/Login/ibbBmail.png" class="desktop">
        </div>
      </div>
      <div class="dashboard hidden-xs" style="overflow-y: scroll; height: 100vh; overflow-x: hidden">
        <div style="height: auto;">
          <div class="card">
            <div class="card-title">
              <h2>{{ $t('records.receiver') }}</h2>
            </div>

            <div class="card-content">
              <h4>{{ this.inbox }}</h4>
              <br />
              <p><strong>{{ $t('records.addressee') }}</strong></p>
              <p>{{ this.receiver }}</p>
            </div>
          </div>

          <div class="card">
            <div class="card-title">
              <h2>{{ $t('records.recordInfo') }}</h2>
            </div>

            <div class="card-content">
              <p>{{ $t('records.email') }}</p>
              <input class="input input--block" v-focus type="email" v-model.trim="email" :disabled="isLogged">

              <p>{{ $t('records.subject') }}</p>
              <input class="input input--block" type="text" v-model.trim="subject">

              <p>{{ $t('records.message') }}</p>
              <textarea class="input input--block" type="text" v-model.trim="message" rows="5"></textarea>

              <p>{{ $t('records.files') }}</p>
              <div>
                <listing ref="downloads-list"></listing>
              </div>
              <input style="display:none" type="file" id="upload-file-to-record" @change="uploadInput($event)" multiple>
              <button :aria-label="$t('buttons.addFile')" :title="$t('buttons.addFile')" @click="addFile" id="buttonAddFile" class="button button--flat" type="submit" >
                <span>{{ $t('buttons.addFile') }}</span>
              </button>
              <br>
              <button :aria-label="$t('records.send')" :title="$t('records.send')" @click="submit" id="buttonAddFile" class="button button--flat" type="submit" >
                <span>{{ $t('records.send') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Listing from '@/components/records/Listing.vue';
import { mapGetters, mapState } from 'vuex';
import { files as fileapi } from '@/api';

export default {
  name: 'share',
  components: {
    Listing
  },
  data: () => ({
    loaded: false,
    notFound: false,
    progress: 0,
    email: '',
    subject: '',
    message: '',
    root: null,
    error: null,
    isFocusEmail: false,
    isFocusSubject: false,
    receiver: '',
    inbox: '',
    description: '',
    userName: '',
    linkInbox: ''
  }),
  watch: {
    '$route': 'fetchData',
  },
  created: async function () {
    let thisComponent = this;
    let JavaEventListenerClass = Module.ActionListener.extend('ActionListener', {
      onActionStart: function(action)
      {
          if (action.type != Module.ActionType.UPLOAD_TO_RECORD.value
            && action.type != Module.ActionType.REMOVE_FROM_RECORD.value) {
            return;
          }
      },
      onActionProgress: function(action)
      {
          if (action.type != Module.ActionType.UPLOAD_TO_RECORD.value) {
            return;
          }

          if (thisComponent.req.items)
          {
            for (let i = 0; i < thisComponent.req.items.length; i++) {
              if (thisComponent.req.items[i]['tag'] == action.tag) {
                let value = action.size ? action.completed * 100 / action.size : 0;
                let index = i;
                thisComponent.$store.commit('updateTransferProgress', { index , value });
                return;
              }
            }

            thisComponent.fetchData();
          }
      },
      onActionFinish: function(action)
      {
        if (action.type != Module.ActionType.REMOVE_FROM_RECORD.value
          && action.type != Module.ActionType.CLEAR_FINISHED_TRANSFERS.value
          && action.type != Module.ActionType.CANCEL_TRANSFERS.value) {
          return;
        }
        thisComponent.fetchData();
      } 
    });

    this.interfaceObject = new JavaEventListenerClass();
    ibbLink.addActionListener(this.interfaceObject);

    try {
      let action = await ibbLink.resumeRecord(document.location.href);
      if (action.error.type) {
        throw new Error('Error resuming record: ' +  action.error.type);
      }

      action = await ibbLink.getNodes();
      if (action.error.type) {
        this.error = action.error.type;
        return;
      }

      action = await ibbLink.getRootNode(Module.NodeType.CLOUD_ROOT.value);
      if (action.error.type) {
        throw new Error('Error getting record: ' +  action.error.type);
      }

      this.root = action.node;

      if (this.root.subject === 'Invalid name') {
        this.subject = '';
      } else {
        this.subject = this.root.subject;
      }

      if (this.root.message === undefined) {
        this.message = '';
      } else {
        this.message = this.root.message;
      } 
      
    } catch (e) {
      this.$showError(e);
      return;
    }

    this.fetchData();
  },
  async mounted () {
    if (this.isLogged) {
      try {
        let action = await ibb.currentEmail();
        this.email = action.email;
      } catch (e) {
        this.$showError(e);
      }
    }

    this.linkInbox = JSON.parse(localStorage.getItem('linkInbox'));
    if (this.linkInbox === '') {
      this.error = 1;
    } else {
      this.receiver = this.linkInbox.name;
      this.inbox = this.linkInbox.node.name;
      this.description = this.linkInbox.node.message;
      let name = this.receiver.split(' ');
      this.userName = name[0].substr(0, 1) + name[1].substr(0, 1);
    }
  },
  beforeDestroy () {
    localStorage.setItem('linkInbox', '');
    ibbLink.removeActionListener(this.interfaceObject);
  },
  computed: {
    ...mapGetters([
      'selectedCount',
      'isListing',
      'isEditor',
      'isFiles',
      'isLogged'
    ]),
    ...mapState([
      'req',
      'user',
      'reload',
      'multiple',
      'loading',
    ]),
    link: function () {
      return document.location.href;
    },
    fullLink: function () {
      return document.location.href;
    }
  },
  methods: {
    focusEmailOn () {
      this.isFocusEmail = true;
    },
    focusEmailOff () {
      this.isFocusEmail = false;
      this.updateRecordInfo();
    },
    focusSubjectOn () {
      this.isFocusSubject = true;
    },
    focusSubjectOff () {
      this.isFocusSubject = false;
      this.updateRecordInfo();
    },
    updateRecordInfo() {
      ibbLink.setRecordInfo(this.email || '', this.subject || '', this.message || '');
    },
    fetchData: async function () {
      this.loaded = true;

      let re = /(?:\.([^.]+))?$/;
      let data = {};
      data['isTransfers'] = 1;
      data['transferType'] = Module.TransferType.UPLOAD.value;
      data['items'] = [];
      data['numDirs'] = 0;

      let action = await ibbLink.getSortedChildren(this.root.handle, Module.SortOrderType.SORT_ORDER_CREATION_TIME.value);
      if (action.error.type) {
        throw new Error('Error getting uploads: ' +  action.error.type);
      }

      let i;
      for (i = 0; i < action.nodeList.length; i++) 
      {
          let transfer = action.nodeList[i];
          data['items'].push({});
          data['items'][i]['name'] = transfer.name;
          data['items'][i]['extension'] = re.exec(data['items'][i]['name'])[1] || '';
          data['items'][i]['extension'] = data['items'][i]['extension'].toLowerCase();
          data['items'][i]['type'] = fileapi.typeByExtension(data['items'][i]['extension']);
          data['items'][i]['size'] = transfer.size;
          data['items'][i]['completed'] = transfer.size;
          data['items'][i]['progress'] = 100;
          data['items'][i]['status'] = Module.TransferStatus.FINISHED.value;
          data['items'][i]['errorCode'] = 0;
          data['items'][i]['tag'] = 0;
          data['items'][i]['handle'] = transfer.handle;
          data['items'][i]['readonly'] = 0;
          data['items'][i]['index'] = i;
      }

      action = await ibbLink.getUnfinishedTransfers(Module.TransferType.UPLOAD.value);
      if (action.error.type) {
        throw new Error('Error getting uploads: ' +  action.error.type);
      }

      let j = 0;
      for (i = data['items'].length; j < action.actionList.length; i++, j++) 
      {
        let transfer = action.actionList[j];
        data['items'].push({});
        data['items'][i]['transferType'] = transfer.type;
        data['items'][i]['name'] = transfer.text ? transfer.text : transfer.name;
        data['items'][i]['extension'] = re.exec(data['items'][i]['name'])[1] || '';
        data['items'][i]['extension'] = data['items'][i]['extension'].toLowerCase();
        data['items'][i]['type'] = fileapi.typeByExtension(data['items'][i]['extension']);
        data['items'][i]['size'] = transfer.size;
        data['items'][i]['completed'] = transfer.completed;
        data['items'][i]['progress'] = transfer.size ? transfer.completed * 100 / transfer.size : 0;
        data['items'][i]['status'] = transfer.status;
        data['items'][i]['errorCode'] = transfer.errorCode;
        data['items'][i]['tag'] = transfer.transferTag;
        data['items'][i]['handle'] = transfer.handle;
        data['items'][i]['readonly'] = 0;
        data['items'][i]['index'] = i;
      }
      data['numFiles'] = i;

      this.$store.commit('updateRequest', data);
    },
    checkConflict (files, items) {
      if (typeof items === 'undefined' || items === null) {
        items = [];
      }

      let conflict = false;
      let res;
      let nombre;
      let handle;
      let tag;
      let status;
      for (let i = 0; i < files.length; i++) {
        res = items.findIndex(function hasConflict (element) {
          if (element.name === this) {
            nombre = element.name;
            handle = element.handle;
            status = element.status;
            tag = element.tag;
          }
          return (element.name === this);
        }, files[i].name);

        if (res >= 0) {
          conflict = true;
          break;
        }
      }

      if (!conflict) {
        this.uploadFile(files);
        return;
      }

      this.$store.commit('showHover', {
        prompt: 'replace',
        confirm: (event) => {
          event.preventDefault();
          this.$store.commit('closeHovers');
          this.uploadFileConflict(files, nombre, handle, tag, status);
        }
      });
    },
    async uploadFileConflict(files, nombre, handle, tag, status) {
      if (status === Module.TransferStatus.FINISHED.value) {
        try {
          let action = await ibbLink.removeFromRecord(handle);
          if (action.error.type) {
            throw new Error('Error removing file from record: ' +  action.error.type);
          }
        } catch (e) {
          this.$showError(e);
        }
      } else {
        try {
          let action = await ibbLink.cancelTransferByTag(tag);
          if (action.error.type) {
            throw new Error('Error canceling transfer by tag: ' +  action.error.type);
          }
        } catch (e) {
          this.$showError(e);
        }
      }
      Module.deleteFile(nombre);
      this.uploadFile(files);
    },
    uploadFile: async function (files) {
      let thisComponent = this;
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        await Module.registerFile(file);
        ibbLink.uploadToRecord(file.name).then(function(action)
        {
          if (action.error.type) {
            return;
          }

          let name = action.name;
          let re = /(?:\.([^.]+))?$/;
          let extension = re.exec(action.node.name)[1] || '';
          extension = extension.toLowerCase();

          if (extension == 'jpg' || extension == 'jpeg' || extension == 'png' || extension == 'bmp' || extension == 'heic' || extension == 'heif') {
            let file = Module.getFile(name);

            console.log('Image uploaded. Creating metadata. Orientation: ' + file['orientation']);
            let handle = action.node.handle;
            let url = Module.getObjectURL(name);

            let thumbnailName = '///thumbnails/' + handle;
            let previewName = '///previews/' + handle;
            Module.createMetadata(url, Module.MetadataType.META_THUMBNAIL.value, async function(data) {
                console.log('Thumbnail created: ' + data.length + ' bytes');
                Module.createFile(thumbnailName, data);
                await ibbLink.uploadMetadata(thumbnailName, handle, Module.MetadataType.META_THUMBNAIL.value);
                thisComponent.fetchData();
            }, file['orientation']);

            Module.createMetadata(url, Module.MetadataType.META_PREVIEW.value, async function(data) {
                console.log('Preview created: ' + data.length + ' bytes');
                Module.createFile(previewName, data);
                await ibbLink.uploadMetadata(previewName, handle, Module.MetadataType.META_PREVIEW.value);
                thisComponent.fetchData();
            }, file['orientation']);
          } else {
            thisComponent.fetchData();
          }
        });
      }
    },
    uploadInput: function (event) {
      this.checkConflict(event.currentTarget.files, this.req.items);
    },
    addFile: async function () {
      console.log(this.email, this.subject, this.message);
      ibbLink.setRecordInfo(this.email, this.subject, this.message);
      document.getElementById('upload-file-to-record').value = '';
      document.getElementById('upload-file-to-record').click();
    },
    submit: async function () {
      if (!this.email || this.email.length == 0) {
        this.$showWarning(this.$t('records.enterEmail'));
        return;
      }

      //var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z//\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      //if (!re.test(this.email)) {
      //  this.$showWarning(this.$t('records.enterValidEmail'));
      //  return;
      //}

      if (!this.subject || this.subject.length == 0) {
        this.$showWarning(this.$t('records.enterSubject'));
        return;
      }

      if (!this.message || this.message.length == 0) {
        this.$showWarning(this.$t('records.enterMessage'));
        return;
      }

      let action = await ibbLink.setRecordInfo(this.email, this.subject, this.message);
      if (action.error.type) {
        throw new Error('Error setting record info: ' +  action.error.type);
      }

      action = await ibbLink.finishRecord();
      if (action.error.type) {
        throw new Error('Error sending record: ' +  action.error.type);
      }

      this.$router.push({ path: action.link.substring(19) });
    }
  }
};
</script>
